import React, { Children, cloneElement } from 'react';
import { FormGroup as ReactstrapFormGroup, Label } from 'reactstrap';
import classNames from 'classnames';
import { get, omit } from 'lodash';
import { connect } from 'react-redux';
import { getModel, getField, Control } from 'react-redux-form';
import resolveModel from 'react-redux-form/lib/utils/resolve-model';
import { compose, branch, mapProps } from 'recompose';

/* eslint-disable no-param-reassign */

const TransformElement = i => {
  const type = get(i, 'type');
  if (!type) return i;

  let elem = i;
  const { className, children } = i.props;

  switch (type) {
    case Control.text:
    case Control.select:
    case Control.textarea:
    case Control.password:
    case Control.input:
      elem = cloneElement(i, {
        className: classNames('form-control', className),
      });
      break;
    case Control.radio:
    case Control.checkbox:
      elem = cloneElement(i, {
        className: classNames('form-check-input', className),
      });
      break;
    default:
      elem = cloneElement(elem, null, Children.map(children, TransformElement));
  }

  return elem;
};

export const FormGroup = ({
  label,
  check,
  inline,
  children,
  addControlClass = true,
  className,
  model,
  storeSubscription,
  color,
  ...props
}) => {
  if (addControlClass) {
    children = Children.map(children, TransformElement);
  }

  return (
    <ReactstrapFormGroup
      color={color}
      className={classNames(className, { 'form-check-inline': !!inline })}
      check={check}
      {...props}
    >
      {check ? (
        <Label check>
          {children}
          {!!label && [' ', label]}
        </Label>
      ) : (
        [!!label && <Label key="label">{label}</Label>, children]
      )}
    </ReactstrapFormGroup>
  );
};

const connectedFormGroup = compose(
  resolveModel,
  connect((state, { model, className }) => {
    if (!model) return {};
    const modelString = getModel(
      typeof model === 'function' ? model(state) : model,
      state
    );
    const fieldState = getField(state, modelString);

    if (!fieldState) return {};
    if (fieldState.touched && !fieldState.valid) {
      return { className: classNames(className, 'has-danger') };
    } else if (fieldState.touched && fieldState.valid) {
      return { className: classNames(className, 'has-success') };
    } else if (!fieldState.touched && !fieldState.valid) {
      return { className: classNames(className, 'has-warning') };
    }
    return {};
  }),
  mapProps(props =>
    omit(props, ['dispatch', 'model', 'storeSubscription', 'store'])
  )
);

const enhance = compose(branch(props => props.model, connectedFormGroup));

export default enhance(FormGroup);



// WEBPACK FOOTER //
// ./src/components/common/Forms/FormGroup.jsx